import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import { functions } from ".";
// connectFunctionsEmulator(functions, "localhost", 5001);
export const redeemCode = httpsCallable(functions, "redeemCode");
export const getAlgoliaKey = httpsCallable(functions, "getAlgoliaKey");
export const changeSubscription = httpsCallable(functions, "changeSubscription");
export const cancelSubscription = httpsCallable(functions, "cancelSubscription");
export const forceUserWeeklies = httpsCallable(functions, "forceUserWeeklies");
